class i{static isLocalhost(){if(typeof window<"u"){const{hostname:o}=window.location;return o==="localhost"||o==="127.0.0.1"}return  false}static info(o,s){this.isLocalhost()&&console.info(`[INFO] ${o}`,s!==void 0?s:"");}static warn(o,s){this.isLocalhost()&&console.warn(`[WARN] ${o}`,s!==void 0?s:"");}static error(o,s){this.isLocalhost()&&console.error(`[ERROR] ${o}`,s||"");}}

export { i as Logger };
//# sourceMappingURL=contact-channels45.js.map
